<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11cdYtT/tc-custom/9781439667019.jpg?1738411512112" alt="This image is the cover for the book 1958 Colfax Tornado"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1958 Colfax Tornado
      </h1>
      <p class="bookDescription body article font2">
        <p>June 4, 1958, was a muggy and breezy day in western Wisconsin. Across central Minnesota, severe weather was brewing. In the early afternoon, the Minnesota storms crossed the border into Wisconsin. As farmers were tending to milking chores and families were wrapping up the workday and sitting down to supper, one of the worst tornadoes in Wisconsin's history touched down. At 7:07 p.m., what had been multiple, smaller tornadoes combined into one massive F5 tornado that ripped through the village of Colfax, leaving a path of death and destruction that would require months of recovery. In Colfax, 12 people were killed, hundreds were injured, and millions of dollars in damage was done to property. However, in the wake of the storm, a community and its neighbors came together as one to care for the survivors and begin the process of healing and rebuilding.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Troy Knutson
      </h2>
      
      <p class="authorDescription body article">Troy Knutson is a lifelong resident of Colfax and is one of the town's historians, sharing his love of Colfax history with local organizations, members of the community, and students of the elementary school. He is always on the hunt for new stories, pictures, and artifacts to add to his collection. Michelle Knutson teaches history at New Richmond High School and is originally from Dresser, Wisconsin. Troy and Michelle live in Colfax with their two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e50b310